import { fork, all } from "redux-saga/effects";
import authSaga from "./sagas/auth";
import serverConstants from "./sagas/serverConstants";
import ticketsSaga from "./sagas/tickets";

export default function* rootSaga() {
  yield all([fork(authSaga), fork(serverConstants), fork(ticketsSaga)]);
}
